import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrashAlt, faEye } from "@fortawesome/free-solid-svg-icons";
import "../../styles/AdminDataTable.css";
import { generateBoatUrl } from "../../../core/utils/stringUtils";

const BoatsTable = ({ boats, onEdit, onDelete, onBoatSelect, selectAll, onSelectAll }) => {
  const sortedBoats = [...boats].sort((a, b) => (a.is_priority && !b.is_priority ? -1 : !a.is_priority && b.is_priority ? 1 : 0));

  const handleViewClick = (boatItem) => {
    // Abrir la página del bote en una nueva pestaña
    const boatUrl = generateBoatUrl(boatItem);
    window.open(boatUrl, '_blank');
  };

  const formatPrice = (price) => {
    if (!price) return '-';
    return `$${Number(price).toFixed(2)}`;
  };

  return (
    <div className="admin-data-table__container">
      <table className="admin-data-table">
        <thead>
          <tr>
            <th>
              <input type="checkbox" checked={selectAll} onChange={(e) => onSelectAll(e.target.checked)} />
            </th>
            <th>ID</th>
            <th>Name</th>
            <th>Price</th>
            <th>Discount Price</th>
            <th>Category</th>
            <th>Length</th>
            <th>Capacity</th>
            <th>Staterooms</th>
            <th>Bathrooms</th>
            <th>Featured</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {sortedBoats.map((boatItem) => (
            <tr key={boatItem.id} className={boatItem.is_priority ? "is-priority-row" : ""}>
              <td>
                <input type="checkbox" checked={boatItem.isSelected || false} onChange={(e) => onBoatSelect(boatItem.id, e.target.checked)} />
              </td>
              <td>#{boatItem.id}</td>
              <td>{boatItem.name}</td>
              <td>{formatPrice(boatItem.price)}</td>
              <td>{formatPrice(boatItem.discount_price)}</td>
              <td>{boatItem.category.name}</td>
              <td>{boatItem.length || '-'}</td>
              <td>{boatItem.capacity || '-'}</td>
              <td>{boatItem.staterooms || '-'}</td>
              <td>{boatItem.bathrooms || '-'}</td>
              <td>{boatItem.featured ? 'Yes' : 'No'}</td>
              <td>
                <div className="action-buttons">
                  <button className="button secondary" onClick={() => onDelete(boatItem)}>
                    <FontAwesomeIcon icon={faTrashAlt} />
                  </button>
                  <button className="button secondary" onClick={() => onEdit(boatItem)}>
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                  <button className="button secondary" onClick={() => handleViewClick(boatItem)}>
                    <FontAwesomeIcon icon={faEye} />
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default BoatsTable;